import { render, staticRenderFns } from "./accessBind.vue?vue&type=template&id=1e2f10a0&scoped=true"
import script from "./accessBind.vue?vue&type=script&lang=js"
export * from "./accessBind.vue?vue&type=script&lang=js"
import style0 from "./accessBind.vue?vue&type=style&index=0&id=1e2f10a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f10a0",
  null
  
)

export default component.exports